// A subscriber's at-a-glance connectivity state, derived from the live
// PPPoE status + assigned IP. "blocked" = online but parked on a 172.*
// walled-garden IP (RADIUS does that to suspended / unpaid accounts).
// The PHP portal's search.js calls this `displayState`; keeping one copy
// here so the home search dropdown and the switch-users list agree.

export type SubscriberState = "online" | "blocked" | "offline" | "unknown";

export function subscriberState(status: string, address: string): SubscriberState {
  if (status === "online") return /^172\./.test(address || "") ? "blocked" : "online";
  if (status === "offline") return "offline";
  return "unknown";
}

/** Tailwind classes for the small status dot next to a subscriber. */
export function stateDotClass(s: SubscriberState): string {
  return s === "online"
    ? "bg-success"
    : s === "blocked"
      ? "bg-warning"
      : s === "offline"
        ? "bg-muted-foreground/50"
        : "bg-muted-foreground/30";
}

/** Badge tint for a RADIUS `account_status` — active=green, block=yellow,
 *  close=red, anything else=muted. Mirrors the PHP `accountStatusColor`
 *  ("is this subscriber paid up?" at a glance). One copy so every place
 *  it appears (subscriber card, switch-users list, RADIUS Issues) agrees. */
export function accountStatusVariant(s: string | undefined | null): "success" | "warning" | "destructive" | "muted" {
  switch ((s ?? "").toLowerCase()) {
    case "active":
      return "success";
    case "block":
      return "warning";
    case "close":
      return "destructive";
    default:
      return "muted";
  }
}
